import {
  MyRewardsQuery,
  NewProductsOffersQuery,
  useMyRewardsQuery,
  useNewProductsOffersQuery,
} from '@/graphql/generated';
import { fetcherGraphql } from '../fetch.helper';
import { queryClient } from '../query.helper';
import { messageSender } from './wrapper-sender';
import { freshToken } from '../freshToken.helper';
import { appSessionStorage } from '../storage.helper';
import { wrapperStore } from '@/store/wrapper.store';
import { AppLabels } from '@/types/App';

window.toggleStore = function (visible?: boolean) {
  wrapperStore.actions.toggleVisibility(visible);
};

window.updateLabels = function (labels: Partial<AppLabels>) {
  wrapperStore.actions.updateLabels(labels);
};

window.endSession = function () {};

window.hideBackToTheGame = function () {
  appSessionStorage.setItem('hideBackToTheGame', true);
};

window.setGameUserId = function setGameUserId(gameUserId: string) {
  appSessionStorage.setItem('gameUserId', gameUserId);
};

window.getNewRewards = async function () {
  try {
    const token = await freshToken.getToken();
    if (token) {
      const { myRewards } = await queryClient.ensureQueryData<MyRewardsQuery>({
        queryFn: fetcherGraphql(useMyRewardsQuery.document),
        queryKey: useMyRewardsQuery.getKey(),
      });
      messageSender({ message: 'NEW_REWARDS', payload: myRewards.nodes.length });
    }
  } catch {
    messageSender({ message: 'NEW_REWARDS', payload: 0 });
  }
};

window.getNewProducts = async function () {
  const { offers } = await queryClient.ensureQueryData<NewProductsOffersQuery>({
    queryFn: fetcherGraphql(useNewProductsOffersQuery.document),
    queryKey: useNewProductsOffersQuery.getKey(),
  });
  messageSender({ message: 'NEW_PRODUCTS', payload: offers.nodes.length });
};
